export enum RoleEnum {
  DG = 'DG',
  DE = 'DE',
  DP = 'DP',
  RBU = 'RBU',
  BM = 'BM',
  VISITOR = 'VISITOR',
}
